import { Component, OnInit, Input } from '@angular/core';
import { HomeworkFile } from '../../models/homework-file.model';
import { User } from '../../models/user/user.model';
import { AvatarSize } from '../avatar/avatar.component';
import { translate } from '@ngneat/transloco';

@Component({
  selector: 'message-bubble',
  templateUrl: './message-bubble.component.html',
  styleUrls: ['./message-bubble.component.scss']
})
export class MessageBubbleComponent implements OnInit {
    protected innerLoadingQueue: number = 0;
    protected innerId: number|null = null;
    protected innerSubmit: boolean = false;

    @Input() homework: HomeworkFile = new HomeworkFile;

    @Input() reversed: boolean = false;
    @Input() type?: ('messages'|'homeworks') = 'homeworks';
    @Input() boubleBlue: boolean = true;
    @Input() sender?: User;
    @Input() message?: string = '';
    @Input() created?: Date;
    @Input() fileUrl?: string;
    @Input() fileName?: string = translate('Домашно');
    @Input() showSender?: boolean = true;
    @Input() showRole?: boolean = true;
    @Input() avatarSize: AvatarSize = 'medium';
    @Input() messageMime?: string = '';

    loading:boolean = false;
    isVideoFile: boolean = false;
    showVideoPreview = false;

    set loadingQueue(value: number) {
        if (this.innerLoadingQueue !== value) {
            this.innerLoadingQueue = value;

            if (this.innerLoadingQueue <= 0) {
                this.innerLoadingQueue = 0;
                this.loading = false;
            } else {
                this.loading = true;
            }
        }
    }
    get loadingQueue(): number {
        return this.innerLoadingQueue;
    }

    constructor() { }

    ngOnInit(): void {
        if(!this?.homework && !this?.fileUrl) {
            this.loadingQueue++;
        }
        this.loadingQueue--;

        this.isVideoFile = this.homework.mime === 'video/mp4' || this.homework.mime === 'video/quicktime' || this.messageMime === 'video/mp4' || this.messageMime === 'video/quicktime';
    }

    previewVideo(){
        this.showVideoPreview = true;
    }

    onModalVideoAction(action:string){
        if(action === 'close') {
            this.showVideoPreview = false;
        }
    }
}
